import React from 'react';
/* this is a wrapper around multiple fields to allow usage in search forms */


const ObjectField = (props)=> {
    var p = {...props};
    var value = props.value?props.value:props.blank;
    var onChange = (evt) => {
        var newValue = {...value};
        newValue[evt.target.name] = evt.target.value;
        props.onChange({target:{name:props.name,value:newValue}});
    }
    p.onChange = onChange;
    p.value = value;
    return <>{props.children(p)}</>;
}

export default ObjectField;